import { createContext, useContext, type ReactNode } from 'react';
import type { Api } from './api';

const Context = createContext<Api | undefined>(undefined);

export function ApiProvider({ api, children }: { api: Api; children: ReactNode }) {
	return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useApi(): Api {
	const api = useContext(Context);
	if (!api) throw new Error('useApi needs an ApiProvider');
	return api;
}
